/* vault 入库申请 */

import { getInfo } from "@/api/public";
import commonEventJs from '@/common/CommonEventJs';

import NotNull from "@/components/notnull.vue";
import ListPagination from "@/components/listpagination";

export default {
    
    components: {
        NotNull,
        ListPagination
    },
    data() {
        return {
            vaultWareId:'',
            userInfo: getInfo(),

            token: getInfo().ChineseToken, // 用户token
            MemberId: getInfo().MappingUserId, // 用户ID 
            UserId:getInfo().Id,  // 海外ID用户ID
            MemberMobile: getInfo().TelPhone,
            MemberRealName: getInfo().NickName,
            MemberSource: getInfo().MemberSource,

            loading: false,
            valutType: 0,//0：在库未上架，1：在库竞拍 2：在库一口价，3 出库 ，4 售出
            tabType: 2,//1入库 2在库 3出库

            vaultList: [],
            pageTotal: 0,//总条数
            list: [],
            searchForm: {
                MemberId: getInfo().MappingUserId,
                ValutId: '',
                Status: '',//未寄出 = 0, 已寄出 = 1, 已签收 = 2, 已查验 = 3,	
                Code: '',
                Title: '',//商品名称
                PageIndex: 1,//页码
                PageSize: 60,// 每页条数
            },

            submitLoading: false,
            //发货相关
            dialogShipVisible: false,
            ShipForm: { Id: '' },
            shipFormSelVal: null,//已选中的快递对象
            expressList: [],//快递公司列表
            expressListAll: [],//快递公司列表[全部的]
            rulesShip: {
                LogisticsCompany: [{ required: true, trigger: ['change', 'blur'], message: this.$t('vault.SelectCarrier') }],
                TrackingNumber: [{ required: true, trigger: ['change', 'blur'], message: this.$t('vault.EnterTrackingNumber') }],
                Phone: [{ required: true, trigger: ['change', 'blur'], message: this.$t('vault.EnterPhoneNumber') }],
            },
            //查看详情
            dialogDetailVisible: false,
            itemDetail: {},//对象详情
            activeTabName: 'first',

        }
    },
    watch: {},
    created: function () {
        var that = this;
        if(that.$route.params.id){
            that.vaultWareId=   that.$route.params.id
        }
    },
    mounted: function () {
        var that = this;
        that.$nextTick(() => {
            that.GetAllValutByPage()//仓库列表
            that.GetExpressShipper()//快递公司列表
            that.GetVaultList();//入库申请列表
        });
    },
    computed: {
        cardStatus() {
            return [
                { value: '', label: this.$t('base.all')},
                { value: 0, label: this.$t('vault.AwaitingShipment')},
                { value: 1, label: this.$t('vault.AwaitingDelivery')},
                { value: 2, label: this.$t('vault.AwaitingInspection')},
                { value: 3, label: this.$t('vault.InspectionComplete')},
                { value: 5, label: this.$t('vault.AwaitingReturn')},
                { value: 6, label: this.$t('vault.Returned')}
            ]
        },
        cardStatusSet(){
            return function (id) {
                const that = this;
                if(id!=null){
                    return that.cardStatus.filter(val => val.value===id)[0].label;
                }
            }
        },
        ThousandAndDecimal() {
            return function (num) {
                //金额千分位
                return commonEventJs.thousandAndDecimal(num);
            }
        },
        checkReturnCard() {
            return function (data) {
                //const hasStatus = data.some(item => item.Status === 99);
                const hasStatus = data.some(item => item.ReturnInfoId);
                return hasStatus
            }
        },
        showSearchFilter() {
            var that = this;
            return function (data) {
                if (that.searchForm.Status === '' && that.searchForm.ValutId === '') {
                    if (that.list.length) return true
                    else return true
                } else {
                    return true
                }
            }
        }
    },
    methods: {
        gotoContact() {
            this.$root.$emit("contactUS", true);
        },
        //#region 入库申请
        GetVaultList() {
            /*获取入库申请列表*/
            var that = this;

            //console.log('GetVaultList-AuthForm', AuthForm)
            that.loading = true;
            const fun = function (res) {
                // console.log('GetVaultList-res', res)
                if (res.Result === 1) {
                    that.list = res.Data || [];
                    that.pageTotal = res.Count || 0;
                } else {

                }
                that.loading = false;
            }
            if(that.vaultWareId){
                that.searchForm.ValutId=that.vaultWareId
            }
            that.$post(that.$interface['GetByPageForApi'], that.searchForm).then(res => {
                fun(res)
            })
        },
        showDetail(itemDetail) {
            var that = this;
            that.dialogDetailVisible = true;
            const returnCard = {};
            try {
                itemDetail.Details.forEach(item => {
                    // 只处理有 ReturnInfoId 的数据
                    if (item.ReturnInfoId) {
                        const returnId = `${item.ReturnInfoId}`;
                        // 如果这个 ReturnInfoId 还不存在，创建空数组
                        if (!returnCard[returnId]) {
                            returnCard[returnId] = [];
                        }
                        // 将当前对象添加到对应的数组中
                        returnCard[returnId].push(item);
                    }
                });
            } catch (err) { }

            itemDetail['ReturnCard'] = returnCard;
            //console.log('NewItemDetail', itemDetail)
            that.itemDetail = itemDetail;
        },
        handleDetailClose() {
            var that = this;
            that.dialogDetailVisible = false;
            that.itemDetail = {};
        },
        handleTabClick(tab, event) { },
        switchTab(tabName) {
            this.activeTabName = tabName
        },
        cardEdit(obj, type) {
            const url = `/vault/StockInApply/${this.vaultWareId}?id=${obj._id}&type=${type}`;
            // location.href = url;
            this.$router.push(url)
        },
        DelVaultItem(item) {
            /* 删除寄存订单 */
            var that = this;
            that.$confirm(`${that.$t('vault.DeleteThisVault')} ${item.Code}`, that.$t('base.hint'), {
                confirmButtonText: that.$t('base.delete'),
                cancelButtonText: that.$t('base.cancel'),
                type: 'warning'
            }).then(() => {
                if (that.submitLoading) { return }

                that.submitLoading = true;
                //console.log('AuthForm', AuthForm)
                const fun = function (res) {
                    console.log("StorageRemove", res);
                    if (res.Result == 1) {
                        that.$message.success(that.$t('base.Submittedsuccessfully'));
                    } else {
                        that.$message.error(res.Msg);
                    }
                    that.submitLoading = false;
                    that.GetVaultList();
                }
                that.$post(that.$interface['StorageRemove'], { Id: item['_id'] }).then(res => {
                    fun(res)
                })
            }).catch(() => { });
        },
        GetAllValutByPage() {
            /* 获取仓库列表 */
            var that = this;
            const fun = function (res) {
                // console.log("GetAllValutByPage", res);
                if (res.Result == 1) {
                    that.vaultList = res.Data || [];
                } else {
                    that.vaultList = []
                }
            }
            const formData = {
                PageIndex: 1,
                PageSize: 100
            }
            that.$get(that.$interface['GetAllValutByPage'], formData).then(res => {
                fun(res)
            })
        },
        /* 分页*/
        currentChange(val) {
            var that = this;
            that.searchForm.PageIndex = val;
            that.GetVaultList()
            //console.log(`当前页: ${val}`);
        },
        sizeChange(val) {
            var that = this;
            that.searchForm.PageIndex = 1;
            that.searchForm.PageSize = val;
            that.GetVaultList()
            //console.log(`每页 ${val} 条`);
        },

        //发货相关
        GetExpressShipper() {
            /*获取快递公司和编码*/
            var that = this;
            var localList = localStorage.getItem('Card_ExpressShipper') ? JSON.parse(localStorage.getItem('Card_ExpressShipper')) : '';
            var cookieExpress = that.$cookie.get("Card_ExpressShipper");
            if (cookieExpress && localList && localList.length) {
                that.expressList = localList;
                that.expressListAll = localList;
            } else {
                const fun = function (res) {
                    that.expressList = res.Data;
                    that.expressListAll = res.Data;
                    localStorage.setItem('Card_ExpressShipper', JSON.stringify(res.Data))
                    that.$cookie.set("Card_ExpressShipper", true, { expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000), path: '/' });
                }
                that.$get(that.$interface['GetExpressShipper'], '').then(res => {
                    fun(res)
                })
            }
        },
        showShipDialog(obj) {
            var that = this;
            that.dialogShipVisible = true;
            that.itemDetail = obj;
            that.$set(that.ShipForm, 'Id', obj._id);
            
            if(obj.LogisticsCompanyCode){
                that.shipFormSelVal=obj.LogisticsCompanyCode;
            }
            if(obj.TrackingNumber){
                that.$set(that.ShipForm, 'TrackingNumber', obj.TrackingNumber);
            }
        },
        handleShipClose() {
            var that = this;
            that.dialogShipVisible = false;
            that.itemDetail = {};
            that.$set(that.ShipForm, 'LogisticsCompanyCode', '');
            that.$set(that.ShipForm, 'LogisticsCompany', '');
        },
        handleChangeExp(event) {
            var that = this;
            //console.log('handleChangeExp', event)
            that.$set(that.ShipForm, 'LogisticsCompanyCode', event.ShipperCode);
            that.$set(that.ShipForm, 'LogisticsCompany', event.ShipperName);
        },
        ShipSubmit(submitType) {
            /* 填写发货单 */
            var that = this;
            this.$refs.ShipFormRef.validate(valid => {
                if (valid) {
                    if (that.submitLoading) { return }

                    //console.log('AuthForm', AuthForm)

                    if (submitType == 'test') {
                        return false
                    }

                    this.$confirm(that.$t('vault.ConfirmCardInfo'), that.$t('base.hint'), {
                        confirmButtonText: that.$t('base.confirm'),
                        cancelButtonText: that.$t('base.cancel'),
                        type: 'warning'
                    }).then(() => {
                        that.submitLoading = true;
                        const fun = function (res) {
                            console.log("StorageCreate", res);
                            if (res.Result == 1) {
                                that.$message.success('提交成功');
                                that.dialogShipVisible = false;
                            } else {
                                that.$message.error(res.Msg);
                            }
                            that.submitLoading = false;
                            that.GetVaultList();
                        }
                        that.$post(that.$interface['ShipOrder'], that.ShipForm).then(res => {
                            fun(res)
                        })
                    }).catch(() => { });

                } else {
                    that.$message.warning(that.$t('vault.PleaseRequiredInfo'))
                    that.submitLoading = false;
                    return false
                }
            })
        },
        //#endregion 入库申请

    },
    destroyed: function () {
        var that = this;
    }
}


// WEBPACK FOOTER //
// ./src/pages/Vault/js/vue-VaultStockInMgt.js